import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "list", "item", "name", "email"]
  static values = { internalRolesRestriction: Boolean }

  add() {
    const content = this.templateTarget.innerHTML.replace(/NEW_ROLE/g, new Date().getTime().toString())
    this.listTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    this.itemTargets
      .find(item => item.contains(event.target))
      .remove()
  }

  nameTargetConnected() {
    // wait for selectize to initialize
    setTimeout(() => this.updateAvailableNames())
  }

  nameTargetDisconnected() {
    this.updateAvailableNames()
  }

  updateAvailableNames() {
    this.nameTargets.forEach(select => {
      const takenValues = this.nameTargets
        .filter(element => element !== select)
        .map(element => element.value)

      if (this.restrictInternalRoles()) {
        takenValues.push("admin", "super_admin")
      }

      select["select"].hideOptions(takenValues)
    })
  }

  restrictInternalRoles() {
    const bmxEmailDomainPresent = /@butterflymx\.com$/.test(this.emailTarget.value)

    return this.internalRolesRestrictionValue && !bmxEmailDomainPresent
  }
}
